// RFC-strict email validation matching backend email_validator gem (strict mode)
// See: config/initializers/email_validator.rb
const EMAIL_REGEX =
  /^[-a-zA-Z0-9+_!"'#$%^&*{}/=?`|~]+(?:\.[-a-zA-Z0-9+_!"'#$%^&*{}/=?`|~]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;

export function isValidEmail(value: string): boolean {
  return EMAIL_REGEX.test(value.trim());
}

export function isValidPassword(value: string, minLength: number): boolean {
  return value.length >= minLength;
}
